import React, { ComponentProps } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { SharedFilesDefaultView } from './views/SharedFilesDefaultView';

type SharedFilesBlockProps = Views<DefaultView<SharedFilesDefaultView>>;

/**
 * Shared files Block.
 */
function SharedFiles({ views }: SharedFilesBlockProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;

  if (active) {
    // no block in edit mode
    return null;
  }

  return <SharedFilesDefaultView {...views.default} />;
}

export const SharedFilesBlock = asBlock(SharedFiles, BlockType.sharedfiles);
export type SharedFilesBlock = ComponentProps<typeof SharedFilesBlock>;
